module.exports = __webpack_public_path__ + "img/images_vip_012.3e7b4693.png";